export default __webpack_public_path__ + "static/media/HowItWorks-06.931b8337.jpg";